import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, MenuStateProvider, MenuButton, Menu, MenuItem } from '@maui/elements'
import { defaultOptions, ranges, rangeConfigurations } from './options'

const checkIcon = <Icon name="check" size="sm" ml="4px" />

export const RangeMenu = ({
  value,
  range,
  ranges = defaultOptions.ranges,
  onChange
}) => {
  const key = value?.toString() === '1' ? 'singular' : 'plural'

  return (
    <MenuStateProvider initialState={{ placement: 'bottom-start' }}>
      <MenuButton variant="secondary" display="flex" alignItems="center" width="104px">
        <Box flex="1">{rangeConfigurations[range][key]}</Box>
        <Icon name="angle-down" ml="4px" />
      </MenuButton>
      <Menu width="140px">
        {ranges.map(r =>
          <MenuItem
            key={r}
            display="flex"
            alignItems="center"
            onClick={() => onChange(r)}
          >
            <Box flex="1">
              {rangeConfigurations[r][key]}
            </Box>
            {r === range && checkIcon}
          </MenuItem>
        )}
      </Menu>
    </MenuStateProvider>
  )
}

RangeMenu.propTypes = {
  value: PropTypes.number,
  range: PropTypes.oneOf(ranges),
  ranges: PropTypes.arrayOf(PropTypes.oneOf(ranges)),
  onChange: PropTypes.func.isRequired,
}
